import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const fieldTimeState = (state: RootState) => state.scene.dashboard.fieldTimeState;

export const getFieldTimeDrillDownViewState = createSelector(
  fieldTimeState,
  ({ viewState }) => viewState
);

export const getFieldTimeDrillDownTotalFilteredRecords = createSelector(
  fieldTimeState,
  ({ totalFilteredRecords }) => totalFilteredRecords
);

export const getFieldTimeDrillDownCustomDateRange = createSelector(
  fieldTimeState,
  ({ drillDownCustomDateRange }) => drillDownCustomDateRange
);

export const getFieldTimeDrillDownConfiguration = createSelector(
  fieldTimeState,
  ({ configuration }) => configuration
);

export const isFieldTimeDrillDownLoading = createSelector(fieldTimeState, ({ loading }) => loading);
